<idea-component-loader></idea-component-loader>
<app-alerts></app-alerts>
<router-outlet></router-outlet>
